// Vue
import { Vue, Component, Prop, Inject, Watch } from "vue-property-decorator";

// Template
import template from "./template.vue";

// components
import { ImageAspectRatio } from "../../../../components/image_aspect_ratio/ImageAspectRatio";
import { Branche } from "#/common/interfaces/conversionworld/Branche";

@Component({
  mixins: [template],
  components: {
    ImageAspectRatio,
  },
})
export class SoftkonfiguratorItem extends Vue {
  @Prop()
  link!: string;

  @Prop()
  img!: string;

  @Prop()
  title!: string;
}
